export default __webpack_public_path__ + "static/media/world.3e7fcad3.svg";